import { useState, useEffect, useRef, useLayoutEffect, useContext } from 'react';
import { ControllerOpenModals } from '../../../../models';
import {
    getChildNodes,
    getDatesBetweenDates,
    getInterruptionsListBetweenDates,
    getWorkshiftScheduling,
} from '../../../../utils';
import { AppContext } from '../../../context';
import {
    controllerAdditionalTimeModal,
    controllerAidTypesModal,
    controllerBusinessUnitsModal,
    controllerCopyWorkshiftSchedulings,
    controllerCostCenterModal,
    controllerDisassociatedBusinessUnitsModal,
    controllerDisassociatedCostCentersModal,
    controllerExceptionalWorkshiftModal,
    controllerIDeleteWorkshiftModal,
    controllerInterruptionModal,
    controllerModifyAdditionalTimeModal,
    controllerModifyInterruptionModal,
    controllerOpenBonusModal,
    controllerOpenWorkshiftModal,
    controllerPasteWorkshiftSchedulings,
    controllerPrintInterruptionsModal,
    controllerRemoveExceptionalWorkshiftModal,
} from '../../../controller-open-modals';
import './app.css';
import { getActionService } from '../../../../utils/getActionService';
import { ACTIONS } from '../../../../constants';
import { controllerCreateTimeAttendanceEventsModal } from '../../../controller-open-modals/controllerCreateTimeAttendanceEventsModal';
import { controllerModifyTimeAttendanceEventsModal } from '../../../controller-open-modals/controllerModifyTimeAttendanceEventsModal';
import { controllerDetailsInconsistenciesModal } from '../../../controller-open-modals/controllerDetailsInconsistenciesModal';
import { controllerAssignAvailability } from '../../../controller-open-modals/controllerAssignAvailability';
import { controllerRemoveAvailability } from '../../../controller-open-modals/controllerRemoveAvailability';
import { controllerAssingOperationCenterModal } from '../../../controller-open-modals/controllerAssingOperationCenterModal';
import { controllerDeleteOperationCenterModal } from '../../../controller-open-modals/controllerRemoveOperationCenterModal';
import { set } from 'mobx';
import { controllerMultipleCostCentersByHourRangesModal } from '../../../controller-open-modals/controllerMultipleCostCentersByHourRangesModal';

const ContextMenu = ({
    targetId,
    startDate,
    endDate,
    treeEmployees,
    openAdditionalHours,
    openDeleteWorkshiftModal,
    openInterruptionModal,
    openUpdateAndDeleteAdditionalHoursModal,
    openUpdateAndDeleteInterruptionsModal,
    openWorkshiftModal,
    openBonusModal,
    openMultipleCostCentersByHourRangesModal,
    openCostCenterModal,
    openBusinessUnitsModal,
    openAidTypesModal,
    openDisassociatedBusinessUnitsModal,
    openDisassociatedCostCenterModal,
    openCopyWorkshiftsSchedulings,
    openSavePasteWorkshiftsSchedulings,
    saveExceptionalWorkshiftsScheduling,
    modifyAssociateTimeAttendanceEvents,
    openAssociateTimeAttendanceEvents,
    handlerValidateNovelties,
    saveAssignAvailability,
    removeAssignAvailability,
}: ControllerOpenModals) => {
    const {
        grid,
        userInfo,
        langResources,
        workshiftShedulingList,
        interruptionList,
        workshiftsSchedulingsCopied,
        downloadReport,
        removeExceptionalWorkshiftsScheduling,
        isSkinSmart,
        isCollapseTree,
        inconsistenciesValidation,
        handlerOpenDetailsInconsistenciesModal,
        allTimeAttendanceEvents,
        handlerOpenOperationsCenterModal,
        handlerDeleteOperationsCenterModal,
    } = useContext(AppContext);

    const [contextData, setContextData] = useState({
        visible: false,
        posX: 0,
        posY: 0,
    });

    const contextRef = useRef(null);

    useEffect(() => {
        const contextMenuEventHandler = (event: any) => {
            const targetElement = document.getElementById(targetId ?? '');

            if (targetElement && targetElement.contains(event.target)) {
                event.preventDefault();
                setContextData({
                    visible: true,
                    posX: event.clientX,
                    posY: event.clientY / 2,
                });
            } else if (
                contextRef.current &&
                // @ts-ignore
                !contextRef.current.contains(event.target)
            ) {
                setContextData({ ...contextData, visible: false });
            }
        };

        const offClickHandler = (event: any) => {
            // @ts-ignore
            if (contextRef.current && !contextRef.current.contains(event.target)) {
                setContextData({ ...contextData, visible: false });
            }
        };

        document.addEventListener('contextmenu', contextMenuEventHandler);
        document.addEventListener('click', offClickHandler);
        return () => {
            document.removeEventListener('contextmenu', contextMenuEventHandler);
            document.removeEventListener('click', offClickHandler);
        };
    }, [contextData, targetId]);

    useLayoutEffect(() => {
        if (
            // @ts-ignore
            contextData.posX + contextRef.current?.offsetWidth >
            // @ts-ignore
            window.innerWidth
        ) {
            setContextData({
                ...contextData,
                // @ts-ignore
                posX: contextData.posX - contextRef.current?.offsetWidth / 3,
            });
        } else if (
            // @ts-ignore
            contextData.posY + contextRef.current?.offsetHeight >
            // @ts-ignore
            window.innerHeight - contextRef.current?.offsetHeight / 2
        ) {
            setContextData({
                ...contextData,
                // @ts-ignore
                posY: contextData.posY - contextRef.current?.offsetHeight / 3,
            });
        }
    }, [contextData]);

    const openWorkshift = () => {
        controllerOpenWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openWorkshiftModal,
        });
    };

    const openDeleteWorkshift = () => {
        controllerIDeleteWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            openDeleteWorkshiftModal,
            getWorkshiftScheduling,
        });

        setContextData({ ...contextData, visible: false });
    };

    const openExceptionalWorkshift = () => {
        controllerExceptionalWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            saveExceptionalWorkshiftsScheduling,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openRemoveExceptionalWorkshift = () => {
        controllerRemoveExceptionalWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            removeExceptionalWorkshiftsScheduling,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openInterruption = () => {
        controllerInterruptionModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openInterruptionModal,
            getWorkshiftScheduling,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openUpdateInterruptions = () => {
        controllerModifyInterruptionModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            getInterruptionsList: getInterruptionsListBetweenDates,
            openUpdateAndDeleteInterruptionsModal,
            interruptionList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openAdditionalsHours = () => {
        controllerAdditionalTimeModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openAdditionalHours,
            getWorkshiftScheduling,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openUpdateAdditionalHours = () => {
        controllerModifyAdditionalTimeModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            openUpdateAndDeleteAdditionalHoursModal,
        });
        setContextData({ ...contextData, visible: false });
    };

    const downloadInterrptionFormat = () => {
        controllerPrintInterruptionsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            langResources,
            downloadReport,
            getInterruptionsList: getInterruptionsListBetweenDates,
            interruptionList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openCostCenter = () => {
        controllerCostCenterModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openCostCenterModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openBusinessUnits = () => {
        controllerBusinessUnitsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openBusinessUnitsModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openAidType = () => {
        controllerAidTypesModal({
            grid,
            startDate,
            endDate,
            treeEmployees,
            openAidTypesModal,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openDisassociatedCostCenter = () => {
        controllerDisassociatedCostCentersModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openDisassociatedCostCenterModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openDisassociatedBusinessUnits = () => {
        controllerDisassociatedBusinessUnitsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openDisassociatedBusinessUnitsModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openCopyWorkshiftsScheduling = () => {
        controllerCopyWorkshiftSchedulings({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            openCopyWorkshiftsSchedulings,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openPasteWorkshiftsScheduling = () => {
        controllerPasteWorkshiftSchedulings({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftsSchedulingsCopied,
            openSavePasteWorkshiftsSchedulings,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openAssignAvailability = () => {
        if (saveAssignAvailability)
            controllerAssignAvailability({
                grid,
                treeEmployees,
                startDate,
                endDate,
                workshiftShedulingList,
                getWorkshiftScheduling,
                saveAssignAvailability,
            });
        setContextData({ ...contextData, visible: false });
    };

    const openRemoveAvailability = () => {
        if (removeAssignAvailability)
            controllerRemoveAvailability({
                grid,
                treeEmployees,
                startDate,
                endDate,
                workshiftShedulingList,
                getWorkshiftScheduling,
                removeAssignAvailability,
            });
        setContextData({ ...contextData, visible: false });
    };

    const openMarkings = () => {
        controllerCreateTimeAttendanceEventsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openAssociateTimeAttendanceEvents,
            getWorkshiftScheduling,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openModifyMarkings = () => {
        controllerModifyTimeAttendanceEventsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            modifyAssociateTimeAttendanceEvents,
            getWorkshiftScheduling,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openDetailsInconsistencies = () => {
        controllerDetailsInconsistenciesModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            inconsistenciesValidation,
            handlerOpenDetailsInconsistenciesModal,
        });
        setContextData({ ...contextData, visible: false });
    };

    const OpenOperationsCenter = () => {
        controllerAssingOperationCenterModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            handlerOpenOperationsCenterModal,
        });
        setContextData({ ...contextData, visible: false });
    };

    const OpenRemoveOparationsCenter = () => {
        controllerDeleteOperationCenterModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            handlerDeleteOperationsCenterModal,
            getWorkshiftScheduling,
        });
        setContextData({ ...contextData, visible: false });
    };

    const openAssignBonus = () => {
        controllerOpenBonusModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openBonusModal: openBonusModal,
        });
        setContextData({ ...contextData, visible: false });
    }

    const openMultipleCostCentersByHourRanges = () => {
        controllerMultipleCostCentersByHourRangesModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openMultipleCostCentersByHourRangesModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
        setContextData({ ...contextData, visible: false });
    };

    return (
        <div
            ref={contextRef}
            className='contextMenu'
            style={{
                display: `${contextData.visible ? 'block' : 'none'}`,
                left: isCollapseTree
                    ? contextData.posX - 150
                    : contextData.posX - 300,
                top: contextData.posY,
                borderRadius: 15,
                zIndex: 99999,
            }}
        >
            <div className={`optionsList`}>
                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.workshift.scheduling']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openWorkshift}
                    >
                        {langResources['context.menu.add.workshift']}
                    </li>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['delete.workshift.scheduling']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openDeleteWorkshift}
                    >
                        {langResources['context.menu.delete.workshift']}
                    </li>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.exceptional']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openExceptionalWorkshift}
                    >
                        {langResources['context.menu.add.exceptional.workshift']}
                    </li>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.exceptional']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openRemoveExceptionalWorkshift}
                    >
                        {langResources['context.menu.remove.exceptional.workshift']}
                    </li>
                )}

                {(getActionService(
                    userInfo.actions,
                    ACTIONS['create.interruption']
                ) ||
                    getActionService(
                        userInfo.actions,
                        ACTIONS['modify.interruption']
                    ) ||
                    getActionService(
                        userInfo.actions,
                        ACTIONS['daily.attendance']
                    )) && <hr className='p-0 m-1' />}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.interruption']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openInterruption}
                    >
                        {langResources['context.menu.add.interruption']}
                    </li>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['modify.interruption']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openUpdateInterruptions}
                    >
                        {langResources['context.menu.delete.update.interruption']}
                    </li>
                )}

                {getActionService(userInfo.actions, ACTIONS['daily.attendance']) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={downloadInterrptionFormat}
                    >
                        {langResources['context.menu.print.interruptions']}
                    </li>
                )}

                {(getActionService(
                    userInfo.actions,
                    ACTIONS['modify.additionals']
                ) ||
                    getActionService(
                        userInfo.actions,
                        ACTIONS['create.additional']
                    )) && <hr className='p-0 m-1' />}
                <div
                    className={`optionSubList d-xxl-block d-flex justify-content-between align-items-center`}
                >
                    <span className='optionSubList__title w-100 optionListItem context__menu--item m-0 p-0'>
                        {langResources['context.menu.additional.info']}
                    </span>

                    <div className='optionSubList__wrapper text-black'>
                        {getActionService(
                            userInfo.actions,
                            ACTIONS['create.additional']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openAdditionalsHours}
                            >
                                {langResources['context.menu.add.additional.hours']}
                            </li>
                        )}

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['modify.additionals']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openUpdateAdditionalHours}
                            >
                                {
                                    langResources[
                                        'context.menu.updated.additional.hours'
                                    ]
                                }
                            </li>
                        )}

                        <hr className='p-0 m-1' />

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['modify.news']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openCostCenter}
                            >
                                {langResources['context.menu.add.cost.center']}
                            </li>
                        )}
                        
                        {getActionService(
                            userInfo.actions,
                            ACTIONS['modify.news']
                        ) &&(
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openMultipleCostCentersByHourRanges}
                            >
                                {langResources['context.menu.add.multiple.cost.center']}
                            </li>
                        )}

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['modify.news']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openDisassociatedCostCenter}
                            >
                                {
                                    langResources['disassociate.cost.center.modal'][
                                        'title'
                                    ]
                                }
                            </li>
                        )}

                        <hr className='p-0 m-1' />

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['assingSchedule.operationCenter']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={OpenOperationsCenter}
                            >
                                {'Asignar Centro de Operaciones'}
                            </li>
                        )}

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['deleteSchedule.operationCenter']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={OpenRemoveOparationsCenter}
                            >
                                {'Eliminar Centro de Operaciones'}
                            </li>
                        )}

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['modify.news']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openBusinessUnits}
                            >
                                {langResources['context.menu.add.business.unit']}
                            </li>
                        )}

                        {getActionService(
                            userInfo.actions,
                            ACTIONS['modify.news']
                        ) && (
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openDisassociatedBusinessUnits}
                            >
                                {
                                    langResources[
                                        'disassociate.business.units.modal'
                                    ]['title']
                                }
                            </li>
                        )}
                    </div>

                    <div className='optionSubList__icon'>
                        <i className='mdi mdi-chevron-right' />
                    </div>
                </div>

                <hr className='p-0 m-1' />

                <li
                    className='optionListItem context__menu--item'
                    onClick={openDetailsInconsistencies}
                >
                    {langResources['context.menu.inconsistencies.details']}
                </li>

                <hr className='p-0 m-1' />

                {getActionService(
                    userInfo.actions,
                    ACTIONS['associate.markings']
                ) && (
                    <div
                        className={`optionSubList d-xxl-block d-flex justify-content-between align-items-center`}
                    >
                        <span className='optionSubList__title w-100 optionListItem context__menu--item m-0 p-0'>
                            {langResources['context.menu.time.attendance.events']}
                        </span>

                        <div className='optionSubList__wrapper text-black'>
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openMarkings}
                            >
                                {
                                    langResources[
                                        'context.menu.add.time.attendance.events'
                                    ]
                                }
                            </li>

                            <li
                                className='optionListItem context__menu--item'
                                onClick={openModifyMarkings}
                            >
                                {
                                    langResources[
                                        'context.menu.edit.time.attendance.events'
                                    ]
                                }
                            </li>
                        </div>

                        <div className='optionSubList__icon'>
                            <i className='mdi mdi-chevron-right' />
                        </div>
                    </div>
                )}

                <hr className='p-0 m-1' />

                {getActionService(
                    userInfo.actions,
                    ACTIONS['assign.availability']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openAssignAvailability}
                    >
                        {langResources['context.menu.assign.availability.details']}
                    </li>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['assign.availability']
                ) && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openRemoveAvailability}
                    >
                        {langResources['context.menu.remove.availability.details']}
                    </li>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['assign.bonus']
                ) && (
                        <>
                            <hr className='p-0 m-1' />
                            <li
                                className='optionListItem context__menu--item'
                                onClick={openAssignBonus}
                            >
                                {langResources['context.menu.assign.bonus']}
                            </li>
                        </>
                    )}



                <hr className='p-0 m-1' />

                <li
                    className='optionListItem context__menu--item'
                    onClick={openCopyWorkshiftsScheduling}
                >
                    {langResources['paste.programation']['copy.label']}
                </li>

                {workshiftsSchedulingsCopied.toCopy.length > 0 && (
                    <li
                        className='optionListItem context__menu--item'
                        onClick={openPasteWorkshiftsScheduling}
                    >
                        {langResources['paste.programation']['paste.label']}
                    </li>
                )}
            </div>
        </div>
    );
};

export default ContextMenu;
